import React from "react";

// /document-api?i=system-usage-flow
export default function SystemUsageFlow() {
  return (
    <>
              <h5 className="fw-bold">1. Sending Credential Information</h5>
              <p>
                When you provide your credentials (e.g., Email, IP Address for
                connection, Callback URL) to SwiftGoldPay, the Admin will create
                an account for you.
              </p>
              <p>
                Login information, such as Username and Email, will be sent to
                your contact channel.
              </p>
              <h5 className="fw-bold">2. Email Verification</h5>
              <p>
                After the Admin has created your account, the system will send
                an Email Verification to your email address.
              </p>
              <p>
                You must click the <b>Verify Email</b> button to activate your
                account.
              </p>
              <div className="fw-bold mb-2">Conditions:</div>
              <ul>
                <li>
                  The email verification link is valid for <b>1 hour</b>.
                </li>
                <li>
                  If the link expires, you can request a new verification email
                  at <a href="/resend-verification">/resend-verification</a>{" "}
                  (or contact the team).
                </li>
              </ul>
              <h5 className="fw-bold">3. Accessing the System</h5>
              <p>After successful verification, the Broker can log in at:</p>
              <a href="/">{window.location.origin}</a>
              <h5 className="fw-bold">4. Connecting Deposit/Withdrawal API</h5>
              <p>
                If the Broker wants to connect to the API for deposit/withdrawal
                transactions.
              </p>
    </>
  );
}
